import i18n from "locale/i18n";

export const parseDate = (dateTime?: Date | string | null): Date | null => {
  if (!dateTime) return null;

  if (typeof dateTime === "string") {
    const trimmed = dateTime.trim();
    if (
      !trimmed ||
      trimmed === "-" ||
      trimmed === "—" ||
      trimmed.startsWith("0001-01-01") ||
      trimmed.startsWith("0000-00-00")
    ) {
      return null;
    }

    let dateObj: Date;
    if (!trimmed.includes("Z") && !trimmed.includes("+")) {
      if (trimmed.length === 10) {
        // It's a date-only string like YYYY-MM-DD. Parse as local midnight to avoid timezone shifting.
        dateObj = new Date(trimmed + "T00:00:00");
      } else {
        // API returns "YYYY-MM-DD HH:mm:ss". Since the backend always returns UTC,
        // we append 'Z' to parse it correctly as a UTC timestamp.
        dateObj = new Date(trimmed.replace(" ", "T") + "Z");
      }
    } else {
      dateObj = new Date(trimmed);
    }

    if (isNaN(dateObj.getTime())) return null;
    if (dateObj.getFullYear() <= 1) return null;

    return dateObj;
  }

  const dateObj = new Date(dateTime);
  if (isNaN(dateObj.getTime()) || dateObj.getFullYear() <= 1) return null;
  return dateObj;
};

export const timeFormatter = (dateTime?: Date | string | null) => {
  const dateObj = parseDate(dateTime);
  if (!dateObj) return "—";

  return dateObj.toLocaleTimeString("id-ID", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

export const dateFormatter = (dateTime?: Date | string | null) => {
  const dateObj = parseDate(dateTime);
  if (!dateObj) return "—";

  const locale = i18n?.language === "id" ? "id-ID" : "en-US";
  const day = dateObj.toLocaleDateString(locale, { day: "2-digit" });
  const month = dateObj.toLocaleDateString(locale, { month: "short" });
  const year = dateObj.toLocaleDateString(locale, { year: "numeric" });

  return `${day} ${month} ${year}`;
};

export const dateTimeFormatter = (dateTime?: Date | string | null) => {
  const dateObj = parseDate(dateTime);
  if (!dateObj) return "—";

  const locale = i18n?.language === "id" ? "id-ID" : "en-US";
  const day = dateObj.toLocaleDateString(locale, { day: "2-digit" });
  const month = dateObj.toLocaleDateString(locale, { month: "short" });
  const year = dateObj.toLocaleDateString(locale, { year: "numeric" });
  const time = dateObj.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit", hour12: false });

  return `${day} ${month} ${year}, ${time} WIB`;
};

export const historyDateTimeFormatter = (dateTime?: Date | string | null) => {
  const dateObj = parseDate(dateTime);
  if (!dateObj) return "—";

  const locale = i18n?.language === "id" ? "id-ID" : "en-US";
  const day = dateObj.toLocaleDateString(locale, { day: "2-digit" });
  const month = dateObj.toLocaleDateString(locale, { month: "short" });
  const year = dateObj.toLocaleDateString(locale, { year: "numeric" });
  const time = dateObj.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit", hour12: false });

  return `${day} ${month} ${year}, ${time}`;
};


